import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { I18nModule } from '../../../i18n';
import { CplaceControlSkeletonModule } from '../cplace-control-skeleton';
import { CplaceControlService } from '../shared/cplace-control.service';
import { CplaceSingleTextControlComponent } from './cplace-single-text-control.component';

@NgModule({
  declarations: [CplaceSingleTextControlComponent],
  imports: [CommonModule, CplaceControlSkeletonModule, FormsModule, HttpClientModule, InputTextModule, InputTextareaModule, I18nModule],
  exports: [CplaceSingleTextControlComponent],
  providers: [CplaceControlService],
})
export class CplaceSingleTextControlModule {}
